import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/index';

@Injectable( {
  providedIn: 'root'
} )
export class ExamsFilterService {


  private filterExams = new Subject<any>();
  private openFilterExams = new Subject<any>();
  private clearFilterExams = new Subject<any>();

  filterExams$ = this.filterExams.asObservable();
  openFilterExams$ = this.openFilterExams.asObservable();
  clearFilterExams$ = this.clearFilterExams.asObservable();

  setFilter( event ) {
    this.filterExams.next( event );
  }

  openSidebarFilter( event ) {
    this.openFilterExams.next( event );
  }

  cleanFilter( event ) {
    this.cleanLocalAdvancedFilter( event );
    this.clearFilterExams.next( event );
  }

  saveLocalAdvancedFilter( tipo, data ) {
    localStorage.setItem( `filtro${ tipo }`, JSON.stringify( data ) );
  }

  getLocalAdvancedFilter( tipo ) {
    try {
      let filterName = JSON.parse( localStorage.getItem(  `filtro${ tipo }` ) );
      return filterName;
    } catch ( e ) {
      return null;
    }
  }

  cleanLocalAdvancedFilter( tipo ) {
    localStorage.removeItem(  `filtro${ tipo }` );
  }

  /**
   * Metodo que se encarga de filtar de hacer el filtrado de la lista,
   * hace el filtro teniendo en cuenta la key y el valor, las key no encontradas las ignora,
   * los valores pueden ser multiples (['a','b',....]) o unicos ('tipoA')
   * @param data Array para filtrar datos
   * @param filter objeto con los parametros de busqueda ( la key debe coincidir con el artributo a buscar)
   */
  filtradoCustom( data, filter ) {
    const query = this.queryFiltro( filter );
    return data.filter( ( item ) => {
      for ( let key in query ) {
        if(key === "numeroLote") {
          if ( item.lote[ key ] === undefined || !query[ key ].includes( item.lote[ key ] ) ) {
            return false;
          }
        } else {
          if(key === "tipoEstudio") {
            if ( item.tipoEstudio.descripcion === undefined || !query[ key ].includes( item.tipoEstudio.descripcion ) ) {
              return false;
            }
          } else if (key === "nroDocumentoTrabajador") {
            if ( item.trabajador.numeroDocumento === undefined || !query[ key ].includes( item.trabajador.numeroDocumento ) ) {
              return false;
            }
          } else if (key === "tipoDocumentoTrabajador") {
            if ( item.trabajador.tipoDocumentoCodigo === undefined || !query[ key ].includes( item.trabajador.tipoDocumentoCodigo.toString() ) ) {
              return false;
            }
          } else {
            if ( item[ key ] === undefined || !query[ key ].includes( item[ key ] ) ) {
              return false;
            }
          }
        }
      }
      return true;
    } );
  }

  /**
   * Metodo que se encarga de crear el objeto para la query de la lista
   * descarta los valores en null y/o los array vacios
   * @param filter
   */
  queryFiltro( filter ) {
    let query = {};
    for ( let keys in filter ) {
      if ( ( filter[ keys ] instanceof Array ) && filter[ keys ].length > 0 ) {
        query[ keys ] = filter[ keys ];
      } else if ( !( filter[ keys ] instanceof Array ) && ( filter[ keys ]  && filter[ keys ] !== '' ) ) {
        query[ keys ] = [ filter[ keys ] ];
      }
    }
    return query;
  }

  countFilter( filter ): number {
    let count = 0;
    for ( let keys in filter ) {
      if ( ( filter[ keys ] instanceof Array ) && filter[ keys ].length > 0 ) {
        count++;
      } else if ( !( filter[ keys ] instanceof Array ) && ( filter[ keys ] && filter[ keys ] !== '' ) ) {
        count++;
      }
    }
    return count;
  }
}
